class Siem {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.enableSiemCheckbox();
        this.disableSiemCheckbox();
        this.siemFormValidation();
        this.initSendTestMessageButton();
    }
    initSendTestMessageButton(){
        const thisClass = this;
        let button = document.getElementById('sendTestMessageButton');
        if(button){
            button.addEventListener('click', function () {
                thisClass.showSendTestDataSwal('', 'info');
            });
        }
    }
    enableSiemCheckbox(){
        function uncheckCheckbox(checkbox) {
            checkbox.checked = false;
        }

        let siemSettingsModal = document.getElementById('siem_settings_modal');
        let checkbox = document.getElementById('openSiemSettingsModal');
        if(checkbox && siemSettingsModal) {
            checkbox.addEventListener('change', (event) => {
                if(event.currentTarget.checked){
                    bootstrap.Modal.getOrCreateInstance(siemSettingsModal).show();
                    siemSettingsModal.addEventListener('hide.bs.modal', function() {
                        uncheckCheckbox(checkbox);
                    });
                } else {
                    siemSettingsModal.removeEventListener('hide.bs.modal', function() {
                        uncheckCheckbox(checkbox);
                    });
                }
            });
        }
    }
    disableSiemCheckbox(){
        let thisClass = this;
        let checkbox = document.getElementById('disableSiemCheckbox');
        if(checkbox){
            checkbox.addEventListener('change', (event) => {
                event.preventDefault();
                if (event.currentTarget.disabled === false) {
                    let checked = event.currentTarget.checked;
                    let html = `
                        <div class="text-center text-primary">Are you sure you want to <b>disable</b> SIEM?</div>
                        <div class="text-center text-primary mt-5"><b>Please note:</b> <br> Your SIEM settings will be removed!</div>
                        <div class="form-check mt-5">
                            <input class="form-check-input float-none corsor-pointer" name="agreeSwalCheckbox" type="checkbox" value="" id="agreeSwalCheckbox" />
                            <label class="form-check-label text-primary corsor-pointer" for="agreeSwalCheckbox">
                                I agree
                            </label>
                        </div>`;
                    Swal.fire({
                        html: html,
                        icon: "warning",
                        iconColor: "#FF5206",
                        buttonsStyling: false,
                        reverseButtons: true,
                        showCancelButton: true,
                        confirmButtonText: "Save changes",
                        customClass: {
                            confirmButton: "btn btn-danger mt-0",
                            cancelButton: 'btn btn-light-primary mt-0',
                        },
                        showLoaderOnConfirm: true,
                        returnFocus: false,
                        preConfirm: async () => {
                            let agreeSwalCheckbox = document.querySelector('input[name="agreeSwalCheckbox"]');
                            if (agreeSwalCheckbox && !agreeSwalCheckbox.checked) {
                                Swal.showValidationMessage(`You need to agree`);
                                return;
                            }

                            return naja.makeRequest('GET', '/siem/?do=disableSiem', {
                                'organizationID': thisClass.organizationID
                            }, {
                                history: false // Prevent URL changes in browser history
                            }).then((response) => {
                                return response.result;
                            });
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                        allowEscapeKey: () => !Swal.isLoading()
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if(result.value.success === true){
                                thisClass.enableSiemCheckbox();
                                toastr.success('SIEM have been successfully disabled!');
                            } else {
                                toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                                Swal.close();
                            }
                        } else {
                            checkbox.checked = !checked;
                        }
                    });
                }
            });
        }
    }
    siemFormValidation(){
        let thisClass = this;
        let form = document.getElementById('frm-siemForm-siemForm');
        if(form){
            let submitButton = document.getElementById('siem_settings_form_submit');
            let caDropzone = this.initCaCert(form, submitButton);
            this.initProtocolSelect(form, caDropzone);

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'host': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    min: 3,
                                    max: 128,
                                    message: 'Host has to be between 3 and 110 characters long',
                                },
                                regexp: {
                                    regexp: /^([a-z.\-\d])+$|^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))$/,
                                    message: 'Colon and slash are not allowed characters',
                                },
                                callback: {
                                    message: 'Enter a public IP address',
                                    callback: function(input) {
                                        const value = input.value;
                                        // If it's a hostname (not an IP), the validation will pass
                                        if (!/^(\d{1,3}\.){3}\d{1,3}$/.test(value)) {
                                            return true;
                                        }

                                        const parts = value.split('.').map(Number);
                                        if (parts.length !== 4) return false;

                                        const [a, b] = parts;

                                        // We know the private ranges:
                                        // 10.0.0.0 – 10.255.255.255
                                        // 172.16.0.0 – 172.31.255.255
                                        // 192.168.0.0 – 192.168.255.255
                                        if (
                                            a === 10 ||
                                            (a === 172 && b >= 16 && b <= 31) ||
                                            (a === 192 && b === 168)
                                        ) {
                                            return false;
                                        }

                                        return true;
                                    }
                                }
                            }
                        },
                        'port': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 5,
                                    message: 'Port cannot be over 5 characters',
                                },
                                callback: {
                                    message: 'You have to type in valid port/range',
                                    callback: function (input) {
                                        /** (0-65535) */
                                        if(!isNaN(+input.value)){
                                            if(+input.value > 0 && +input.value <= 65535){
                                                return true;
                                            }
                                        }
                                        return false;
                                    }
                                }
                            }
                        },
                        'data[]': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            },
                        }
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: '',
                            defaultMessageContainer: false
                        }),
                        message: new FormValidation.plugins.Message({
                            clazz: 'fv-plugins-message-container invalid-feedback',
                            container: function (field, ele) {
                                if (field === 'data[]') {
                                    return form.querySelector('#atLeastOneDataEnabled');
                                }
                                return FormValidation.utils.closest(ele, '.fv-row');
                            }
                        }),
                    }
                }
            );

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                validator.validate().then(function(status) {
                    if (status === 'Valid') {
                        new DismissModal('siem_settings_modal').disable();
                        // Show loading indication
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        // Disable button to avoid multiple click
                        submitButton.disabled = true;
                        $('#frm-siemForm-siemForm').submit();
                    }
                });
            });

            $.nette.ext('siemForm', {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === 'frm-siemForm-siemForm'){
                        if(payload){
                            thisClass.disableSiemCheckbox();
                            if(payload.result){
                                toastr.success('SIEM settings have been successfully saved!');
                                if(payload.showTestDataModal){
                                    thisClass.showSendTestDataSwal('SIEM settings have been saved!', 'success');
                                }
                            } else {
                                let checkbox = document.getElementById('openSiemSettingsModal');
                                if(checkbox){
                                    checkbox.checked = !checkbox.checked; // set previous state
                                }
                                toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                            }
                        } else {
                            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                        }

                        new DismissModal('siem_settings_modal').enable();
                        bootstrap.Modal.getInstance(document.getElementById('siem_settings_modal')).hide();

                        // Cancel loading indication
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;

                        thisClass.initSendTestMessageButton();
                    }
                }
            });
        }
    }
    showSendTestDataSwal(title = '', icon = undefined){
        const thisClass = this;
        Swal.fire({
            title: title,
            html: `<span class="text-center text-primary">To make sure you\'ve set up your SIEM correctly, you can send a test message to see if your SIEM will accept it.`,
            icon: icon,
            iconColor: icon === 'success' ? "#36B37E" : "#0E2B8F",
            buttonsStyling: false,
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: "Send test message",
            customClass: {
                confirmButton: "btn btn-danger mt-0",
                cancelButton: 'btn btn-light-primary mt-0',
            },
            showLoaderOnConfirm: true,
            returnFocus: false,
            preConfirm: () => {
                return fetch('/siem?do=sendTestData&organizationID=' + thisClass.organizationID)
                    .then(async response => {
                        if (!response.ok) {
                            throw new Error(response.statusText)
                        }
                        let result = await response.json();
                        if (result) {
                            toastr.success('Test message has been successfully sent!');
                        } else {
                            toastr.error('Failed to send test message. Your SIEM settings are not valid. Please try it again later or contact our support team.');
                        }
                        return false;
                    }).catch(error => {
                        Swal.showValidationMessage(`Request failed: ${error}`)
                    });
            },
            allowOutsideClick: () => false,
            allowEscapeKey: () => false
        }).then((result) => {

        });
    }
    initCaCert(form, submitButton){
        let dropzoneEl = form.querySelector('#ca-cert-file');

        if(dropzoneEl){
            let deleteCert = form.querySelector('.delete-saved-cert-button');
            // Remove saved cert
            if(deleteCert){
                deleteCert.addEventListener('click', function () {
                    form.querySelector('#tls-enabled').classList.add('d-none');
                    form.querySelector('#cert-preview').remove();
                    dropzoneEl.classList.remove('d-none');
                });
            }

            // set the preview element template
            let previewNode = dropzoneEl.querySelector(".dropzone-item");
            let previewTemplate = previewNode.parentNode.innerHTML;
            if(previewNode.classList.contains('d-none')){
                previewNode.parentNode.removeChild(previewNode);
            }

            let caDropzone = new Dropzone(dropzoneEl, {
                url: "/siem/validate-cert", // Set the url for check script
                maxFiles: 1,
                acceptedFiles: '.crt,.pem',
                parallelUploads: 1,
                maxFilesize: 1, // Max filesize in MB
                previewTemplate: previewTemplate,
                previewsContainer: dropzoneEl.querySelector(".dropzone-items"), // Define the container to display the previews
                clickable: dropzoneEl.querySelector(".dropzone-attach") // Define the element that should be used as click trigger to select files.
            });

            caDropzone.on("success", function (file, response) {
                if(response.success){
                    form.querySelector('#tls-enabled').classList.remove('d-none');
                    form.querySelector('input[name="cert"]').value = response.plainCertificate;

                    let certPreview = dropzoneEl.querySelector('[data-dz-certpreview]');
                    dropzoneEl.querySelector('#certificate-container').classList.remove('d-none');
                    certPreview.innerText = response.plainCertificate;

                    dropzoneEl.querySelector('[data-dz-expiration]').innerText = '(Expiration: '+response.expirationDate+')';
                } else {
                    form.querySelector('#tls-enabled').classList.add('d-none');
                    form.querySelector('input[name="cert"]').value = '';

                    file.accepted = false;
                    if (file.previewElement) {
                        file.previewElement.classList.add("dz-error");
                        for (let node of file.previewElement.querySelectorAll(
                            "[data-dz-errormessage]"
                        )) {
                            node.textContent = response.message;
                        }
                    }
                }
            });

            caDropzone.on("addedfile", function (file, response) {
                // Hookup the start button
                const dropzoneItems = dropzoneEl.querySelectorAll('.dropzone-item');
                dropzoneItems.forEach(dropzoneItem => {
                    dropzoneItem.classList.remove('d-none');
                });
                dropzoneEl.querySelector('.dropzone-attach').classList.add('d-none');
            });

            // On all files removed
            caDropzone.on("removedfile", function (file) {
                form.querySelector('input[name="cert"]').value = '';
                form.querySelector('#tls-enabled').classList.add('d-none');
                dropzoneEl.querySelector('.dropzone-attach').classList.remove('d-none');
            });

            // Update the total progress bar
            caDropzone.on("totaluploadprogress", function (progress) {
                const progressBars = dropzoneEl.querySelectorAll('.progress-bar');
                progressBars.forEach(progressBar => {
                    progressBar.style.width = progress + "%";
                });
            });

            caDropzone.on("sending", function (file) {
                submitButton.disabled = true;

                // Show the total progress bar when upload starts
                const progressBars = dropzoneEl.querySelectorAll('.progress-bar');
                progressBars.forEach(progressBar => {
                    progressBar.style.opacity = "1";
                });
            });

            // Hide the total progress bar when nothing"s uploading anymore
            caDropzone.on("complete", function (progress) {
                const progressBars = dropzoneEl.querySelectorAll('.dz-complete');

                setTimeout(function () {
                    progressBars.forEach(progressBar => {
                        progressBar.querySelector('.progress-bar').classList.add('d-none');
                        progressBar.querySelector('.progress').classList.add('d-none');
                    });
                }, 300);

                submitButton.disabled = false;
            });

            return caDropzone;
        }
        return null;
    }
    initProtocolSelect(form, caDropzone){
        let protocolSelect = form.querySelector('select[name="protocol"]');
        let certContainer = form.querySelector('#ca-cert-container');
        if(protocolSelect && certContainer){
            $(protocolSelect).on('select2:select', function (e) {
                if(this.value === '2'){
                    certContainer.classList.add('d-none');
                    if(caDropzone){
                        caDropzone.removeAllFiles();
                        let certInput = form.querySelector('input[name="cert"]');
                        if(certInput){
                            certInput.value = '';
                        }
                    }
                } else {
                    certContainer.classList.remove('d-none');
                }
            });
        }
    }
}
window.Siem = Siem;